export enum TipoContaBancaria {
  CORRENTE = 0,
  POUPANCA = 1,
  MERCADOMONETARIO = 2,
  LINHA_CREDITO = 3,
  NA = 4,
}
